module.exports = __webpack_public_path__ + "static/media/dentistaEConsultorioOdontologico.9fc8ad91.svg";